import './FundCriteriaSelect.css';
import '../../../Common/typography.css';
import ToggleButton from '../../../Common/ToggleButton/ToggleButton';
import { FundCriteria } from '../../../../types/fundScreener.type';
import {
  FC_GROUPS,
  MAX_SELECTED_CRITERIA,
} from '../../../../constants/fundScreener/fundCriteria.constant';

interface FundCriteriaSelectProps {
  criteria: FundCriteria[];
  setCriteria: (criteria: FundCriteria[]) => void;
}

const FundCriteriaSelect = ({
  criteria,
  setCriteria,
}: FundCriteriaSelectProps) => {
  const selectedCount = criteria.filter((item) => item.selected).length;

  const toggleCriteria = (id: string, selected: boolean) => {
    if (!selected && selectedCount >= MAX_SELECTED_CRITERIA) return;
    setCriteria(
      criteria.map((item) =>
        item.id === id
          ? {
              ...item,
              selected: !selected,
              selectedMin: undefined,
              selectedMax: undefined,
              scores: undefined,
              // Toggling off and back on must start fresh, same as Reset
              // All — these were missing, so a previously selected company
              // (or currency) silently survived an unselect/reselect cycle.
              companyName: undefined,
              currency: undefined,
            }
          : item,
      ),
    );
  };

  return (
    <div className="fund-criteria-select-options">
      <div className="fund-criteria-select-count body-s-regular">
        {selectedCount}/{MAX_SELECTED_CRITERIA} selected
      </div>
      {Object.values(FC_GROUPS).map((group) => (
        <div key={group} className="fund-criteria-select-group">
          <div className="fund-criteria-select-group-label body-m-bold">{group}</div>
          {criteria
            .filter((item) => item.group === group)
            .map((option) => {
              const disabled = !option.selected && selectedCount >= MAX_SELECTED_CRITERIA;
              return (
                <div
                  key={option.id}
                  className={`fund-criteria-select-option-item ${disabled ? 'disabled' : ''}`}
                  role="option"
                  aria-selected={option.selected}
                  aria-disabled={disabled}
                  onClick={() => toggleCriteria(option.id, option.selected)}
                  tabIndex={0}
                >
                  <ToggleButton
                    className="fund-criteria-select-option-toggle"
                    label={option.label}
                    checked={option.selected}
                    indeterminate={false}
                    onClick={() => toggleCriteria(option.id, option.selected)}
                  />
                </div>
              );
            })}
        </div>
      ))}
    </div>
  );
};

export default FundCriteriaSelect;
